/*
 * 木漏れ日シェーダー（hero-lab/main.js からの移植）
 * 素のWebGL1実装。Three.js等の依存なし。フラグメントシェーダーはモックと差分ゼロ。
 */
(function () {
  'use strict';

  // 既定値。管理画面のパラメータ(JSON)が空/不正のときのフォールバック。
  var DEFAULTS = {
    // Wall layer
    wallAngle: -60,
    wallScale: 1.6,
    wallStretch: 2.6,
    wallThreshLo: 0,
    wallThreshHi: 0.77,
    wallIntensity: 1.14,
    wallSpeed: 0.12,
    wallWarpAmp: 0.15,
    wallWarpScale: 0.1,
    wallClusterScale: 1.95,
    wallClusterAmount: 0.3,
    wallDetail: 0,
    wallOffsetX: -1.1,
    wallOffsetY: -0.14,
    wallY: 0.64,
    wallSoft: 0.07,

    // Wall light pool gate (amount 0 = full coverage, no gating)
    wallPoolCx: 0.41,
    wallPoolCy: 0.84,
    wallPoolRx: 0.32,
    wallPoolRy: 0.74,
    wallPoolFeather: 0.47,
    wallPoolAmount: 0.68,

    // Floor layer
    floorAngle: 5,
    floorScale: 2.95,
    floorStretch: 1,
    floorThreshLo: 0.01,
    floorThreshHi: 0.64,
    floorIntensity: 1.35,
    floorSpeed: 0.12,
    floorWarpAmp: 0.15,
    floorWarpScale: 0.1,
    floorClusterScale: 0.05,
    floorClusterAmount: 0.27,
    floorDetail: 0,
    floorOffsetX: -1.46,
    floorOffsetY: 0.63,
    floorY: 0.81,
    floorSoft: 0.22,
    floorPersp: 3.05,

    // Floor light pool gate (amount 0 = full coverage, no gating)
    floorPoolCx: 0.63,
    floorPoolCy: 0.25,
    floorPoolRx: 0.41,
    floorPoolRy: 0.26,
    floorPoolFeather: 0.39,
    floorPoolAmount: 0.81,

    // Global
    tint: '#ffe9cf',

    // Mask 1 (product protection: center tall bottle)
    maskCx: 0.47,
    maskCy: 0.57,
    maskRx: 0.14,
    maskRy: 0.31,
    maskFeather: 0.35,
    maskStrength: 0.66,

    // Mask 2 (product protection: right cream jar)
    mask2Cx: 0.63,
    mask2Cy: 0.31,
    mask2Rx: 0.1,
    mask2Ry: 0.16,
    mask2Feather: 0.35,
    mask2Strength: 0.66,

    // Global
    shadeIntensity: 0,
    dprCap: 3,

    // 描画負荷の調整。lightScale = 光を計算する解像度の倍率（写真は常に等倍）、
    // fps = 1秒あたりの描画回数の上限。
    lightScale: 0.5,
    fps: 30,
    octaves: 3,
  };

  // 調整ラボ(hero-lab.js)がGUIを機械生成するためのパラメータ説明表。
  // folder / label / 範囲はモック(hero-lab/main.js)の lil-gui 定義と同一。
  var META = {
    wallAngle: { folder: 'Wall', label: 'angle', min: -90, max: 90, step: 1 },
    wallScale: { folder: 'Wall', label: 'scale', min: 0.5, max: 8, step: 0.05 },
    wallStretch: { folder: 'Wall', label: 'stretch', min: 1, max: 6, step: 0.05 },
    wallThreshLo: { folder: 'Wall', label: 'coverage lo', min: 0, max: 1, step: 0.01 },
    wallThreshHi: { folder: 'Wall', label: 'coverage hi', min: 0, max: 1, step: 0.01 },
    wallIntensity: { folder: 'Wall', label: 'intensity', min: 0, max: 1.5, step: 0.01 },
    wallSpeed: { folder: 'Wall', label: 'speed', min: 0, max: 0.2, step: 0.001 },
    wallWarpAmp: { folder: 'Wall', label: 'warpAmp', min: 0, max: 1.5, step: 0.01 },
    wallWarpScale: { folder: 'Wall', label: 'warpScale', min: 0.1, max: 5, step: 0.05 },
    wallClusterScale: { folder: 'Wall', label: 'clusterScale', min: 0.05, max: 2, step: 0.01 },
    wallClusterAmount: { folder: 'Wall', label: 'clusterAmount', min: 0, max: 1, step: 0.01 },
    wallDetail: { folder: 'Wall', label: 'detail', min: 0, max: 1, step: 0.01 },
    wallOffsetX: { folder: 'Wall', label: 'offsetX', min: -2, max: 2, step: 0.01 },
    wallOffsetY: { folder: 'Wall', label: 'offsetY', min: -2, max: 2, step: 0.01 },
    wallY: { folder: 'Wall', label: 'y', min: 0, max: 1.5, step: 0.01 },
    wallSoft: { folder: 'Wall', label: 'soft', min: 0, max: 1, step: 0.01 },
    wallPoolCx: { folder: 'Wall', label: 'poolCx', min: -0.5, max: 1.5, step: 0.01 },
    wallPoolCy: { folder: 'Wall', label: 'poolCy', min: -0.5, max: 1.5, step: 0.01 },
    wallPoolRx: { folder: 'Wall', label: 'poolRx', min: 0.05, max: 1.5, step: 0.01 },
    wallPoolRy: { folder: 'Wall', label: 'poolRy', min: 0.05, max: 1.5, step: 0.01 },
    wallPoolFeather: { folder: 'Wall', label: 'poolFeather', min: 0, max: 1, step: 0.01 },
    wallPoolAmount: { folder: 'Wall', label: 'poolAmount', min: 0, max: 1, step: 0.01 },

    floorAngle: { folder: 'Floor', label: 'angle', min: -90, max: 90, step: 1 },
    floorScale: { folder: 'Floor', label: 'scale', min: 0.5, max: 8, step: 0.05 },
    floorStretch: { folder: 'Floor', label: 'stretch', min: 1, max: 6, step: 0.05 },
    floorThreshLo: { folder: 'Floor', label: 'coverage lo', min: 0, max: 1, step: 0.01 },
    floorThreshHi: { folder: 'Floor', label: 'coverage hi', min: 0, max: 1, step: 0.01 },
    floorIntensity: { folder: 'Floor', label: 'intensity', min: 0, max: 1.5, step: 0.01 },
    floorSpeed: { folder: 'Floor', label: 'speed', min: 0, max: 0.2, step: 0.001 },
    floorWarpAmp: { folder: 'Floor', label: 'warpAmp', min: 0, max: 1.5, step: 0.01 },
    floorWarpScale: { folder: 'Floor', label: 'warpScale', min: 0.1, max: 5, step: 0.05 },
    floorClusterScale: { folder: 'Floor', label: 'clusterScale', min: 0.05, max: 2, step: 0.01 },
    floorClusterAmount: { folder: 'Floor', label: 'clusterAmount', min: 0, max: 1, step: 0.01 },
    floorDetail: { folder: 'Floor', label: 'detail', min: 0, max: 1, step: 0.01 },
    floorOffsetX: { folder: 'Floor', label: 'offsetX', min: -2, max: 2, step: 0.01 },
    floorOffsetY: { folder: 'Floor', label: 'offsetY', min: -2, max: 2, step: 0.01 },
    floorY: { folder: 'Floor', label: 'y', min: 0, max: 1.5, step: 0.01 },
    floorSoft: { folder: 'Floor', label: 'soft', min: 0, max: 1, step: 0.01 },
    floorPersp: { folder: 'Floor', label: 'persp', min: 1, max: 5, step: 0.05 },
    floorPoolCx: { folder: 'Floor', label: 'poolCx', min: -0.5, max: 1.5, step: 0.01 },
    floorPoolCy: { folder: 'Floor', label: 'poolCy', min: -0.5, max: 1.5, step: 0.01 },
    floorPoolRx: { folder: 'Floor', label: 'poolRx', min: 0.05, max: 1.5, step: 0.01 },
    floorPoolRy: { folder: 'Floor', label: 'poolRy', min: 0.05, max: 1.5, step: 0.01 },
    floorPoolFeather: { folder: 'Floor', label: 'poolFeather', min: 0, max: 1, step: 0.01 },
    floorPoolAmount: { folder: 'Floor', label: 'poolAmount', min: 0, max: 1, step: 0.01 },

    maskCx: { folder: 'Mask', label: 'cx', min: 0, max: 1, step: 0.01 },
    maskCy: { folder: 'Mask', label: 'cy', min: 0, max: 1, step: 0.01 },
    maskRx: { folder: 'Mask', label: 'rx', min: 0.01, max: 1, step: 0.01 },
    maskRy: { folder: 'Mask', label: 'ry', min: 0.01, max: 1, step: 0.01 },
    maskFeather: { folder: 'Mask', label: 'feather', min: 0, max: 1, step: 0.01 },
    maskStrength: { folder: 'Mask', label: 'strength', min: 0, max: 1, step: 0.01 },
    mask2Cx: { folder: 'Mask', label: 'cx 2', min: 0, max: 1, step: 0.01 },
    mask2Cy: { folder: 'Mask', label: 'cy 2', min: 0, max: 1, step: 0.01 },
    mask2Rx: { folder: 'Mask', label: 'rx 2', min: 0.01, max: 1, step: 0.01 },
    mask2Ry: { folder: 'Mask', label: 'ry 2', min: 0.01, max: 1, step: 0.01 },
    mask2Feather: { folder: 'Mask', label: 'feather 2', min: 0, max: 1, step: 0.01 },
    mask2Strength: { folder: 'Mask', label: 'strength 2', min: 0, max: 1, step: 0.01 },

    tint: { folder: 'Global', label: 'tint', type: 'color' },
    shadeIntensity: { folder: 'Global', label: 'shadeIntensity', min: 0, max: 1, step: 0.01 },
    dprCap: { folder: 'Global', label: 'dprCap', min: 0.5, max: 3, step: 0.1 },
    lightScale: { folder: 'Global', label: 'lightScale', min: 0.25, max: 1, step: 0.05 },
    fps: { folder: 'Global', label: 'fps', min: 15, max: 60, step: 1 },
    octaves: { folder: 'Global', label: 'octaves', min: 1, max: 4, step: 1 },
  };

  // 管理画面の data-params（Copy JSON貼り付け）を既定値に上書きマージ
  function resolveParams(raw) {
    var p = {};
    for (var k in DEFAULTS) p[k] = DEFAULTS[k];
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        for (var key in parsed) {
          if (key in DEFAULTS && typeof parsed[key] === typeof DEFAULTS[key]) {
            p[key] = parsed[key];
          }
        }
      } catch (e) {
        console.debug('[hero-fx-komorebi] params JSON parse failed, using defaults', e);
      }
    }
    return p;
  }

  // モック(Three.js)の THREE.Color と同じく sRGB→リニア変換して渡す
  // （承認済みパラメータはこの変換前提で調整されている）
  function hexToRgb(hex) {
    var v = parseInt(hex.replace('#', ''), 16);
    return [(v >> 16) & 255, (v >> 8) & 255, v & 255].map(function (c) {
      c /= 255;
      return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
  }

  var VERTEX_SHADER = [
    'attribute vec2 position;',
    'varying vec2 vUv;',
    'void main() {',
    '  vUv = position * 0.5 + 0.5;',
    '  gl_Position = vec4(position, 0.0, 1.0);',
    '}',
  ].join('\n');

  // 光だけを描くパス。低解像度のバッファへ書き出し、合成パスで拡大して重ねる。
  // 光はぼんやりした模様なので、拡大しても見た目は変わらない。
  var LIGHT_FRAGMENT_SHADER = [
    'precision highp float;',
    '',
    'varying vec2 vUv;',
    '',
    'uniform vec2 uResolution;',
    'uniform vec2 uImageSize;',
    'uniform float uTime;',
    'uniform vec3 uTint;',
    '',
    'uniform float uWallAngle;',
    'uniform float uWallScale;',
    'uniform float uWallStretch;',
    'uniform float uWallThreshLo;',
    'uniform float uWallThreshHi;',
    'uniform float uWallIntensity;',
    'uniform float uWallSpeed;',
    'uniform float uWallWarpAmp;',
    'uniform float uWallWarpScale;',
    'uniform float uWallClusterScale;',
    'uniform float uWallClusterAmount;',
    'uniform float uWallDetail;',
    'uniform vec2 uWallOffset;',
    'uniform float uWallY;',
    'uniform float uWallSoft;',
    '',
    'uniform float uFloorAngle;',
    'uniform float uFloorScale;',
    'uniform float uFloorStretch;',
    'uniform float uFloorThreshLo;',
    'uniform float uFloorThreshHi;',
    'uniform float uFloorIntensity;',
    'uniform float uFloorSpeed;',
    'uniform float uFloorWarpAmp;',
    'uniform float uFloorWarpScale;',
    'uniform float uFloorClusterScale;',
    'uniform float uFloorClusterAmount;',
    'uniform float uFloorDetail;',
    'uniform vec2 uFloorOffset;',
    'uniform float uFloorY;',
    'uniform float uFloorSoft;',
    'uniform float uFloorPersp;',
    '',
    'uniform vec2 uWallPoolCenter;',
    'uniform vec2 uWallPoolRadius;',
    'uniform float uWallPoolFeather;',
    'uniform float uWallPoolAmount;',
    '',
    'uniform vec2 uFloorPoolCenter;',
    'uniform vec2 uFloorPoolRadius;',
    'uniform float uFloorPoolFeather;',
    'uniform float uFloorPoolAmount;',
    '',
    'uniform vec2 uMaskCenter;',
    'uniform vec2 uMaskRadius;',
    'uniform float uMaskFeather;',
    'uniform float uMaskStrength;',
    '',
    'uniform vec2 uMask2Center;',
    'uniform vec2 uMask2Radius;',
    'uniform float uMask2Feather;',
    'uniform float uMask2Strength;',
    '',
    '',
    '// -----------------------------------------------------------------------',
    '// Simplex noise 2D (Ashima Arts / Ian McEwan, MIT license)',
    '// -----------------------------------------------------------------------',
    'vec3 mod289(vec3 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }',
    'vec2 mod289(vec2 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }',
    'vec3 permute(vec3 x) { return mod289(((x * 34.0) + 1.0) * x); }',
    '',
    'float snoise(vec2 v) {',
    '  const vec4 C = vec4(0.211324865405187, 0.366025403784439,',
    '                      -0.577350269189626, 0.024390243902439);',
    '  vec2 i  = floor(v + dot(v, C.yy));',
    '  vec2 x0 = v - i + dot(i, C.xx);',
    '  vec2 i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);',
    '  vec4 x12 = x0.xyxy + C.xxzz;',
    '  x12.xy -= i1;',
    '  i = mod289(i);',
    '  vec3 p = permute(permute(i.y + vec3(0.0, i1.y, 1.0))',
    '          + i.x + vec3(0.0, i1.x, 1.0));',
    '  vec3 m = max(0.5 - vec3(dot(x0, x0), dot(x12.xy, x12.xy), dot(x12.zw, x12.zw)), 0.0);',
    '  m = m * m;',
    '  m = m * m;',
    '  vec3 x = 2.0 * fract(p * C.www) - 1.0;',
    '  vec3 h = abs(x) - 0.5;',
    '  vec3 ox = floor(x + 0.5);',
    '  vec3 a0 = x - ox;',
    '  m *= 1.79284291400159 - 0.85373472095314 * (a0 * a0 + h * h);',
    '  vec3 g;',
    '  g.x = a0.x * x0.x + h.x * x0.y;',
    '  g.yz = a0.yz * x12.xz + h.yz * x12.yw;',
    '  return 130.0 * dot(m, g);',
    '}',
    '',
    '// -----------------------------------------------------------------------',
    '// fbm — 段数は FBM_OCTAVES（パラメータ octaves）で決める',
    '// -----------------------------------------------------------------------',
    'float fbm(vec2 p) {',
    '  float value = 0.0;',
    '  float amp = 0.5;',
    '  for (int i = 0; i < FBM_OCTAVES; i++) {',
    '    value += amp * snoise(p);',
    '    p *= 2.0;',
    '    amp *= 0.5;',
    '  }',
    '  return value;',
    '}',
    '',
    'mat2 rotate2d(float a) {',
    '  float s = sin(a);',
    '  float c = cos(a);',
    '  return mat2(c, -s, s, c);',
    '}',
    '',
    '// -----------------------------------------------------------------------',
    '// Layer field: angled / stretched fbm + domain warp = dappled sunlight',
    '// Used independently for the wall layer and the floor layer.',
    '// -----------------------------------------------------------------------',
    'float layerField(',
    '  vec2 uv, float t, float angle, float scale, float stretch,',
    '  float thLo, float thHi, float speed, float warpAmp, float warpScale,',
    '  float clusterScale, float clusterAmount, float detail, vec2 offset, float persp',
    ') {',
    '  vec2 p = uv - 0.5 + offset;',
    '  p = rotate2d(radians(angle)) * p;',
    '',
    '  // anisotropic stretch along the light streak direction',
    '  p.y *= stretch;',
    '',
    '  // perspective compression (floor layer passes >1.0, wall passes 1.0)',
    '  p.y *= persp;',
    '',
    '  p *= scale;',
    '',
    '  vec2 driftA = vec2(t * speed, -t * speed * 0.7);',
    '  vec2 driftB = vec2(-t * speed * 0.6, t * speed * 0.4);',
    '',
    '  vec2 warp = warpAmp * vec2(',
    '    fbm(p * warpScale + driftA),',
    '    fbm(p * warpScale - driftB)',
    '  );',
    '',
    '  // slow parallel drift on top of the warp',
    '  vec2 pWarped = p + warp + vec2(t * speed * 0.15, 0.0);',
    '',
    '  // main dapples + smaller secondary dapples',
    '  float n = fbm(pWarped);',
    '  float light = smoothstep(thLo, thHi, n);',
    '  // detail が 0 のときは結果に影響しないので計算ごと飛ばす',
    '  if (detail > 0.0) {',
    '    float n2 = fbm(pWarped * 2.7 + 13.0);',
    '    light = max(light, smoothstep(thLo + 0.25, thHi, n2) * detail);',
    '  }',
    '',
    '  // low-freq cluster field: gathers dapples into diagonal bands,',
    '  // leaving calm empty areas (like real komorebi through a tree crown)',
    '  if (clusterAmount > 0.0) {',
    '    float cl = fbm(p * clusterScale + vec2(t * speed * 0.1, 0.0));',
    '    cl = smoothstep(-0.45, 0.45, cl);',
    '    light *= mix(1.0, cl, clusterAmount);',
    '  }',
    '',
    '  return light;',
    '}',
    '',
    '// 光だまりゲート: ソフト楕円の内側だけ光を通す（amount 0 = 全面 100%）',
    'float poolGate(vec2 uv, vec2 center, vec2 radius, float feather, float amount) {',
    '  vec2 q = (uv - center) / radius;',
    '  float inside = 1.0 - smoothstep(1.0 - feather, 1.0 + feather, length(q));',
    '  return mix(1.0, inside, amount);',
    '}',
    '',
    '// -----------------------------------------------------------------------',
    '// cover-fit UV correction（光パス・合成パスで同じ値を使う）',
    '// -----------------------------------------------------------------------',
    'vec2 coverUV(vec2 uv) {',
    '  float screenAspect = uResolution.x / uResolution.y;',
    '  float imageAspect = uImageSize.x / uImageSize.y;',
    '  vec2 scaleUV = vec2(1.0);',
    '  if (screenAspect > imageAspect) {',
    '    scaleUV.y = imageAspect / screenAspect;',
    '  } else {',
    '    scaleUV.x = screenAspect / imageAspect;',
    '  }',
    '  return (uv - 0.5) * scaleUV + 0.5;',
    '}',
    '',
    'void main() {',
    '  vec2 coverUv = coverUV(vUv);',
    '',
    '  // wall / floor zone weights',
    '  float d = 1.0 - coverUv.y;',
    '  float wallW = 1.0 - smoothstep(uWallY - uWallSoft * 0.5, uWallY + uWallSoft * 0.5, d);',
    '  float floorW = smoothstep(uFloorY - uFloorSoft * 0.5, uFloorY + uFloorSoft * 0.5, d);',
    '',
    '  // 帯の外・強度0のレイヤーは計算ごと飛ばす（横帯なので分岐は画面内で揃う）',
    '  float wallL = 0.0;',
    '  if (wallW > 0.0 && uWallIntensity > 0.0) {',
    '    wallL = layerField(',
    '      coverUv, uTime, uWallAngle, uWallScale, uWallStretch,',
    '      uWallThreshLo, uWallThreshHi, uWallSpeed, uWallWarpAmp, uWallWarpScale,',
    '      uWallClusterScale, uWallClusterAmount, uWallDetail, uWallOffset, 1.0',
    '    ) * uWallIntensity * wallW * poolGate(coverUv, uWallPoolCenter, uWallPoolRadius, uWallPoolFeather, uWallPoolAmount);',
    '  }',
    '',
    '  float floorL = 0.0;',
    '  if (floorW > 0.0 && uFloorIntensity > 0.0) {',
    '    floorL = layerField(',
    '      coverUv, uTime, uFloorAngle, uFloorScale, uFloorStretch,',
    '      uFloorThreshLo, uFloorThreshHi, uFloorSpeed, uFloorWarpAmp, uFloorWarpScale,',
    '      uFloorClusterScale, uFloorClusterAmount, uFloorDetail, uFloorOffset, uFloorPersp',
    '    ) * uFloorIntensity * floorW * poolGate(coverUv, uFloorPoolCenter, uFloorPoolRadius, uFloorPoolFeather, uFloorPoolAmount);',
    '  }',
    '',
    '  float light = 1.0 - (1.0 - wallL) * (1.0 - floorL);',
    '',
    '  // product protection mask (ellipse, soft feather)',
    '  vec2 dm = (coverUv - uMaskCenter) / uMaskRadius;',
    '  float maskFalloff = smoothstep(1.0, 1.0 - uMaskFeather, length(dm));',
    '  light *= mix(1.0, 1.0 - uMaskStrength, maskFalloff);',
    '',
    '  vec2 dm2 = (coverUv - uMask2Center) / uMask2Radius;',
    '  float mask2Falloff = smoothstep(1.0, 1.0 - uMask2Feather, length(dm2));',
    '  light *= mix(1.0, 1.0 - uMask2Strength, mask2Falloff);',
    '',
    '  // RGB = screen合成に使う light*tint（1を超えた分は合成後に飽和するので同値）',
    '  // A   = shade合成に使う light',
    '  gl_FragColor = vec4(clamp(light * uTint, 0.0, 1.0), min(light, 1.0));',
    '}',
  ].join('\n');

  // 合成パス。写真は等倍で読むので、光の解像度を落としても写真はボケない。
  var COMPOSITE_FRAGMENT_SHADER = [
    'precision highp float;',
    '',
    'varying vec2 vUv;',
    '',
    'uniform sampler2D uTexture;',
    'uniform sampler2D uLight;',
    'uniform vec2 uResolution;',
    'uniform vec2 uImageSize;',
    'uniform float uShadeIntensity;',
    '',
    'void main() {',
    '  float screenAspect = uResolution.x / uResolution.y;',
    '  float imageAspect = uImageSize.x / uImageSize.y;',
    '  vec2 scaleUV = vec2(1.0);',
    '  if (screenAspect > imageAspect) {',
    '    scaleUV.y = imageAspect / screenAspect;',
    '  } else {',
    '    scaleUV.x = screenAspect / imageAspect;',
    '  }',
    '  vec2 coverUv = (vUv - 0.5) * scaleUV + 0.5;',
    '',
    '  vec3 base = texture2D(uTexture, coverUv).rgb;',
    '  vec4 lit = texture2D(uLight, vUv);',
    '',
    '  vec3 col = 1.0 - (1.0 - base) * (1.0 - lit.rgb);',
    '',
    '  float shade = (1.0 - lit.a) * uShadeIntensity;',
    '  col *= (1.0 - shade);',
    '',
    '  gl_FragColor = vec4(col, 1.0);',
    '}',
  ].join('\n');

  function compileShader(gl, type, source) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      console.debug('[hero-fx-komorebi] shader compile failed', gl.getShaderInfoLog(shader));
      gl.deleteShader(shader);
      return null;
    }
    return shader;
  }

  function createProgram(gl, vsSource, fsSource) {
    var vs = compileShader(gl, gl.VERTEX_SHADER, vsSource);
    var fs = compileShader(gl, gl.FRAGMENT_SHADER, fsSource);
    if (!vs || !fs) return null;

    var program = gl.createProgram();
    gl.attachShader(program, vs);
    gl.attachShader(program, fs);
    gl.linkProgram(program);

    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      console.debug('[hero-fx-komorebi] program link failed', gl.getProgramInfoLog(program));
      gl.deleteProgram(program);
      return null;
    }
    return program;
  }

  function initCanvas(canvas) {
    if (canvas.dataset.heroFxInit === 'true') return;
    canvas.dataset.heroFxInit = 'true';

    // SP素材へ切り替える上限幅。hero.liquid が data-sp-max で渡す（スライダー有効時はタブレットも
    // SP画像を使うため 1024 になる）。属性が無ければ従来どおり 749px。
    // 🔑 picture の <source media> と必ず同じ値にすること。ずれると絵柄とテクスチャが食い違う。
    var spMax = parseInt(canvas.dataset.spMax, 10) || 749;
    var mq = window.matchMedia('(max-width: ' + spMax + 'px)');

    var src = (mq.matches && canvas.dataset.srcSp) ? canvas.dataset.srcSp : canvas.dataset.src;
    if (!src) return;

    var PARAMS = resolveParams((mq.matches && canvas.dataset.paramsSp) ? canvas.dataset.paramsSp : canvas.dataset.params);

    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (!gl) return;

    // 光シェーダーは fbm の段数を define で埋め込んでからコンパイルする
    function buildLightProgram(octaves) {
      var n = Math.min(4, Math.max(1, Math.round(octaves)));
      return createProgram(gl, VERTEX_SHADER, '#define FBM_OCTAVES ' + n + '\n' + LIGHT_FRAGMENT_SHADER);
    }

    var lightProgram = buildLightProgram(PARAMS.octaves);
    var compositeProgram = createProgram(gl, VERTEX_SHADER, COMPOSITE_FRAGMENT_SHADER);
    if (!lightProgram || !compositeProgram) return;

    // Fullscreen triangle (covers -1..3 so the visible -1..1 quad is fully filled)
    var positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);

    var lightPositionLoc;
    var compositePositionLoc = gl.getAttribLocation(compositeProgram, 'position');

    var LIGHT_UNIFORM_NAMES = [
      'uResolution', 'uImageSize', 'uTime', 'uTint',
      'uWallAngle', 'uWallScale', 'uWallStretch', 'uWallThreshLo', 'uWallThreshHi',
      'uWallIntensity', 'uWallSpeed', 'uWallWarpAmp', 'uWallWarpScale',
      'uWallClusterScale', 'uWallClusterAmount', 'uWallDetail', 'uWallOffset',
      'uWallY', 'uWallSoft',
      'uWallPoolCenter', 'uWallPoolRadius', 'uWallPoolFeather', 'uWallPoolAmount',
      'uFloorAngle', 'uFloorScale', 'uFloorStretch', 'uFloorThreshLo', 'uFloorThreshHi',
      'uFloorIntensity', 'uFloorSpeed', 'uFloorWarpAmp', 'uFloorWarpScale',
      'uFloorClusterScale', 'uFloorClusterAmount', 'uFloorDetail', 'uFloorOffset',
      'uFloorY', 'uFloorSoft', 'uFloorPersp',
      'uFloorPoolCenter', 'uFloorPoolRadius', 'uFloorPoolFeather', 'uFloorPoolAmount',
      'uMaskCenter', 'uMaskRadius', 'uMaskFeather', 'uMaskStrength',
      'uMask2Center', 'uMask2Radius', 'uMask2Feather', 'uMask2Strength',
    ];

    var uniforms = {};
    function readLightUniforms() {
      LIGHT_UNIFORM_NAMES.forEach(function (name) {
        uniforms[name] = gl.getUniformLocation(lightProgram, name);
      });
      lightPositionLoc = gl.getAttribLocation(lightProgram, 'position');
    }
    readLightUniforms();

    var compositeUniforms = {};
    ['uTexture', 'uLight', 'uResolution', 'uImageSize', 'uShadeIntensity'].forEach(function (name) {
      compositeUniforms[name] = gl.getUniformLocation(compositeProgram, name);
    });

    var texture = gl.createTexture();
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 255]));
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

    // 光を書き出す低解像度バッファ（ユニット1に常駐）
    var lightTexture = gl.createTexture();
    gl.activeTexture(gl.TEXTURE1);
    gl.bindTexture(gl.TEXTURE_2D, lightTexture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.activeTexture(gl.TEXTURE0);

    var lightFramebuffer = gl.createFramebuffer();
    var lightSize = { width: 0, height: 0 };
    var lightReady = false;

    var tint = hexToRgb(PARAMS.tint);
    var imageSize = [3000, 1714];
    var textureReady = false;

    // 🔑 表示している <img> をそのままテクスチャに使う。
    // 自分で読み直すと、img が srcset から選ぶ幅（1500 等）と data-src の幅（3000）が
    // 食い違って同じ画像を2回落とすため（2026-09-10 実測 76KB + 26KB）。
    // picture が画像を差し替えたときも同じ要素に load が飛ぶので、そのまま貼り直せる。
    var pictureImg = canvas.parentElement ? canvas.parentElement.querySelector('img') : null;
    var usingPictureImg = false;

    function uploadTexture(source) {
      imageSize = [source.naturalWidth, source.naturalHeight];
      gl.activeTexture(gl.TEXTURE0);
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, source);
      textureReady = true;
      canvas.classList.add('is-ready');
      requestRender();
      return true;
    }

    function loadTexture(nextSrc) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        uploadTexture(img);
      };
      img.onerror = function () {
        console.debug('[hero-fx-komorebi] texture load failed', nextSrc);
      };
      img.src = nextSrc;
    }

    // 別ドメインの画像を CORS 無しで貼るとここで例外になるので、その時だけ自分で読み直す
    function tryPictureImg() {
      if (!pictureImg || !pictureImg.complete || !pictureImg.naturalWidth) return false;
      try {
        uploadTexture(pictureImg);
        usingPictureImg = true;
        return true;
      } catch (e) {
        pictureImg = null;
        return false;
      }
    }

    if (pictureImg) {
      pictureImg.addEventListener('load', function () {
        if (pictureImg && !tryPictureImg() && !usingPictureImg) {
          loadTexture(src);
        }
      });
    }
    if (!tryPictureImg() && !pictureImg) {
      loadTexture(src);
    }

    var bufferSize = { width: 0, height: 0 };

    function resize() {
      var rect = canvas.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, PARAMS.dprCap);
      var w = Math.max(1, Math.round(rect.width * dpr));
      var h = Math.max(1, Math.round(rect.height * dpr));
      if (w === bufferSize.width && h === bufferSize.height) return;
      bufferSize.width = w;
      bufferSize.height = h;
      canvas.width = w;
      canvas.height = h;
      resizeLightBuffer();
    }

    // 光バッファは canvas の lightScale 倍。写真の解像度には影響しない。
    function resizeLightBuffer() {
      var scale = Math.min(1, Math.max(0.1, PARAMS.lightScale));
      var w = Math.max(1, Math.round(bufferSize.width * scale));
      var h = Math.max(1, Math.round(bufferSize.height * scale));
      if (w === lightSize.width && h === lightSize.height) return;
      lightSize.width = w;
      lightSize.height = h;

      gl.activeTexture(gl.TEXTURE1);
      gl.bindTexture(gl.TEXTURE_2D, lightTexture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, w, h, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
      gl.activeTexture(gl.TEXTURE0);

      gl.bindFramebuffer(gl.FRAMEBUFFER, lightFramebuffer);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, lightTexture, 0);
      lightReady = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      if (!lightReady) console.debug('[hero-fx-komorebi] light framebuffer incomplete');
    }

    var resizeObserver = new ResizeObserver(resize);
    resizeObserver.observe(canvas);
    resize();

    var isVisible = false;
    var intersectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        isVisible = entry.isIntersecting;
        if (isVisible) requestRender();
      });
    });
    intersectionObserver.observe(canvas);

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var startTime = performance.now();
    var rafId = null;
    var frameCount = 0;

    // スクロール中は描画を止める（合成の負荷を抜いてスクロールを軽くする）。
    // 最後のスクロールからこの時間だけ待ってから再開する。
    var SCROLL_PAUSE_MS = 150;
    var lastScrollAt = -Infinity;
    var pausedAt = 0;
    var pausedTotal = 0;
    var lastDrawAt = -Infinity;

    window.addEventListener('scroll', function () {
      lastScrollAt = performance.now();
      requestRender();
    }, { passive: true });

    function render(now) {
      rafId = null;
      if (!isVisible || !textureReady || !lightReady) return;

      // スクロール中は時間も一緒に止める（再開時に光が飛ばない）
      if (now - lastScrollAt < SCROLL_PAUSE_MS) {
        if (pausedAt === 0) pausedAt = now;
        if (!reducedMotion) requestRender();
        return;
      }
      if (pausedAt !== 0) {
        pausedTotal += now - pausedAt;
        pausedAt = 0;
      }

      // 1秒あたりの描画回数を上限まで間引く
      var interval = 1000 / Math.min(60, Math.max(1, PARAMS.fps));
      if (!reducedMotion && now - lastDrawAt < interval - 1) {
        requestRender();
        return;
      }
      lastDrawAt = now;

      var elapsed = reducedMotion ? 0 : (now - startTime - pausedTotal) / 1000;

      // --- パス1: 光だけを低解像度バッファへ ---
      gl.bindFramebuffer(gl.FRAMEBUFFER, lightFramebuffer);
      gl.viewport(0, 0, lightSize.width, lightSize.height);

      gl.useProgram(lightProgram);

      gl.enableVertexAttribArray(lightPositionLoc);
      gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
      gl.vertexAttribPointer(lightPositionLoc, 2, gl.FLOAT, false, 0, 0);

      // cover計算を合成パスと一致させるため、バッファではなく canvas の寸法を渡す
      gl.uniform2f(uniforms.uResolution, canvas.width, canvas.height);
      gl.uniform2f(uniforms.uImageSize, imageSize[0], imageSize[1]);
      gl.uniform1f(uniforms.uTime, elapsed);
      gl.uniform3f(uniforms.uTint, tint[0], tint[1], tint[2]);

      gl.uniform1f(uniforms.uWallAngle, PARAMS.wallAngle);
      gl.uniform1f(uniforms.uWallScale, PARAMS.wallScale);
      gl.uniform1f(uniforms.uWallStretch, PARAMS.wallStretch);
      gl.uniform1f(uniforms.uWallThreshLo, PARAMS.wallThreshLo);
      gl.uniform1f(uniforms.uWallThreshHi, PARAMS.wallThreshHi);
      gl.uniform1f(uniforms.uWallIntensity, PARAMS.wallIntensity);
      gl.uniform1f(uniforms.uWallSpeed, PARAMS.wallSpeed);
      gl.uniform1f(uniforms.uWallWarpAmp, PARAMS.wallWarpAmp);
      gl.uniform1f(uniforms.uWallWarpScale, PARAMS.wallWarpScale);
      gl.uniform1f(uniforms.uWallClusterScale, PARAMS.wallClusterScale);
      gl.uniform1f(uniforms.uWallClusterAmount, PARAMS.wallClusterAmount);
      gl.uniform1f(uniforms.uWallDetail, PARAMS.wallDetail);
      gl.uniform2f(uniforms.uWallOffset, PARAMS.wallOffsetX, PARAMS.wallOffsetY);
      gl.uniform1f(uniforms.uWallY, PARAMS.wallY);
      gl.uniform1f(uniforms.uWallSoft, PARAMS.wallSoft);

      gl.uniform2f(uniforms.uWallPoolCenter, PARAMS.wallPoolCx, PARAMS.wallPoolCy);
      gl.uniform2f(uniforms.uWallPoolRadius, PARAMS.wallPoolRx, PARAMS.wallPoolRy);
      gl.uniform1f(uniforms.uWallPoolFeather, PARAMS.wallPoolFeather);
      gl.uniform1f(uniforms.uWallPoolAmount, PARAMS.wallPoolAmount);

      gl.uniform1f(uniforms.uFloorAngle, PARAMS.floorAngle);
      gl.uniform1f(uniforms.uFloorScale, PARAMS.floorScale);
      gl.uniform1f(uniforms.uFloorStretch, PARAMS.floorStretch);
      gl.uniform1f(uniforms.uFloorThreshLo, PARAMS.floorThreshLo);
      gl.uniform1f(uniforms.uFloorThreshHi, PARAMS.floorThreshHi);
      gl.uniform1f(uniforms.uFloorIntensity, PARAMS.floorIntensity);
      gl.uniform1f(uniforms.uFloorSpeed, PARAMS.floorSpeed);
      gl.uniform1f(uniforms.uFloorWarpAmp, PARAMS.floorWarpAmp);
      gl.uniform1f(uniforms.uFloorWarpScale, PARAMS.floorWarpScale);
      gl.uniform1f(uniforms.uFloorClusterScale, PARAMS.floorClusterScale);
      gl.uniform1f(uniforms.uFloorClusterAmount, PARAMS.floorClusterAmount);
      gl.uniform1f(uniforms.uFloorDetail, PARAMS.floorDetail);
      gl.uniform2f(uniforms.uFloorOffset, PARAMS.floorOffsetX, PARAMS.floorOffsetY);
      gl.uniform1f(uniforms.uFloorY, PARAMS.floorY);
      gl.uniform1f(uniforms.uFloorSoft, PARAMS.floorSoft);
      gl.uniform1f(uniforms.uFloorPersp, PARAMS.floorPersp);

      gl.uniform2f(uniforms.uFloorPoolCenter, PARAMS.floorPoolCx, PARAMS.floorPoolCy);
      gl.uniform2f(uniforms.uFloorPoolRadius, PARAMS.floorPoolRx, PARAMS.floorPoolRy);
      gl.uniform1f(uniforms.uFloorPoolFeather, PARAMS.floorPoolFeather);
      gl.uniform1f(uniforms.uFloorPoolAmount, PARAMS.floorPoolAmount);

      gl.uniform2f(uniforms.uMaskCenter, PARAMS.maskCx, PARAMS.maskCy);
      gl.uniform2f(uniforms.uMaskRadius, PARAMS.maskRx, PARAMS.maskRy);
      gl.uniform1f(uniforms.uMaskFeather, PARAMS.maskFeather);
      gl.uniform1f(uniforms.uMaskStrength, PARAMS.maskStrength);

      gl.uniform2f(uniforms.uMask2Center, PARAMS.mask2Cx, PARAMS.mask2Cy);
      gl.uniform2f(uniforms.uMask2Radius, PARAMS.mask2Rx, PARAMS.mask2Ry);
      gl.uniform1f(uniforms.uMask2Feather, PARAMS.mask2Feather);
      gl.uniform1f(uniforms.uMask2Strength, PARAMS.mask2Strength);

      gl.drawArrays(gl.TRIANGLES, 0, 3);

      // --- パス2: 写真に光を重ねて画面へ ---
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.viewport(0, 0, canvas.width, canvas.height);

      gl.useProgram(compositeProgram);

      gl.enableVertexAttribArray(compositePositionLoc);
      gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
      gl.vertexAttribPointer(compositePositionLoc, 2, gl.FLOAT, false, 0, 0);

      gl.activeTexture(gl.TEXTURE0);
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.uniform1i(compositeUniforms.uTexture, 0);

      gl.activeTexture(gl.TEXTURE1);
      gl.bindTexture(gl.TEXTURE_2D, lightTexture);
      gl.uniform1i(compositeUniforms.uLight, 1);
      gl.activeTexture(gl.TEXTURE0);

      gl.uniform2f(compositeUniforms.uResolution, canvas.width, canvas.height);
      gl.uniform2f(compositeUniforms.uImageSize, imageSize[0], imageSize[1]);
      gl.uniform1f(compositeUniforms.uShadeIntensity, PARAMS.shadeIntensity);

      gl.drawArrays(gl.TRIANGLES, 0, 3);
      frameCount++;

      if (!reducedMotion) requestRender();
    }

    function requestRender() {
      if (rafId === null) rafId = requestAnimationFrame(render);
    }

    // パラメータ適用（JSON文字列 / オブジェクトのどちらでも受ける）
    function applyParams(raw) {
      var prevDprCap = PARAMS.dprCap;
      var prevLightScale = PARAMS.lightScale;
      var prevOctaves = PARAMS.octaves;
      var json = (typeof raw === 'string') ? raw : JSON.stringify(raw);
      PARAMS = resolveParams(json);
      tint = hexToRgb(PARAMS.tint);
      if (PARAMS.dprCap !== prevDprCap) {
        bufferSize.width = 0; // dprCap が変わった時だけバッファを作り直す（同サイズだと resize が早期returnするため）
        resize();
      } else if (PARAMS.lightScale !== prevLightScale) {
        resizeLightBuffer();
      }
      if (PARAMS.octaves !== prevOctaves) {
        var rebuilt = buildLightProgram(PARAMS.octaves);
        if (rebuilt) {
          gl.deleteProgram(lightProgram);
          lightProgram = rebuilt;
          readLightUniforms();
        }
      }
      requestRender();
    }

    // 画像差し替え（<img> を流用しているときは picture 側が差し替わるので何もしない）
    function loadImage(nextSrc) {
      if (usingPictureImg) return;
      if (nextSrc && nextSrc !== src) {
        src = nextSrc;
        loadTexture(nextSrc);
      }
    }

    // PC/SP のブレークポイントを跨いだとき、パラメータ・色・画像を差し替える。
    // SP用の画像もパラメータも無い canvas はリスナーを張らず、従来と完全に同一挙動。
    if (canvas.dataset.srcSp || canvas.dataset.paramsSp) {
      mq.addEventListener('change', function () {
        applyParams((mq.matches && canvas.dataset.paramsSp) ? canvas.dataset.paramsSp : canvas.dataset.params);
        loadImage((mq.matches && canvas.dataset.srcSp) ? canvas.dataset.srcSp : canvas.dataset.src);
      });
    }

    // 調整ラボ(hero-lab.js)向けの操作API。本番では誰も参照しない。
    canvas.heroFx = {
      fx: 'komorebi',
      defaults: DEFAULTS,
      meta: META,
      getParams: function () {
        var o = {};
        for (var k in PARAMS) o[k] = PARAMS[k];
        return o;
      },
      setParams: applyParams,
      setImage: loadImage,
      getFrameCount: function () { return frameCount; },
    };
    canvas.dispatchEvent(new CustomEvent('hero-fx:ready'));

    requestRender();
  }

  function initAll() {
    if (document.documentElement.classList.contains('no-canvas')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('canvas[data-hero-canvas][data-fx="komorebi"]').forEach(function (canvas) {
      try {
        initCanvas(canvas);
      } catch (e) {
        console.debug('[hero-fx-komorebi] init failed', e);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll();
  }

  // 調整ラボがエフェクトを列挙するためのレジストリ
  window.ReUHeroFX = window.ReUHeroFX || {};
  window.ReUHeroFX.komorebi = { label: '木漏れ日', defaults: DEFAULTS, meta: META };
})();
